import React, { useEffect, useState } from "react";
import { array, object, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import { Link } from "@quintype/components";

import MobilePlayStore from "../../../molecules/MobilePlayStore";
import FooterMenuGroup from "../../../molecules/FooterMenuGroup";

import { Instagram, Facebook, Twitter } from "../../../atoms/icons/StoryPageIcons";
import Youtube from "./Youtube";
import DefaultFooterLogo from "./DefaultFooterLogo";

import { logoRenderer } from "../../../utils/react-utils";
import { getCurrentSite, completeUrlSetter } from "../../../utils/utils";
import { staticTexts } from "../../../utils/Translate";
import { menuGroups } from "../../../helper/api";

import "./defaultFooter.m.css";

const DefaultFooterBase = ({
  publisherSettings,
  prothomaloMenuItems,
  lang,
  socialLinks,
  currentPath,
  domainSlug,
  micrositesMenuItems,
  sections,
}) => {
  const [authMenu, setAuthMenu] = useState({});

  const footerBottom = prothomaloMenuItems.find((item) => item.title === "Footer Bottom");
  const footerBottomLinks = footerBottom && footerBottom.children.length > 0 ? footerBottom.children : null;
  const initialFooterBottomLinks =
    footerBottomLinks && footerBottomLinks.length > 1 ? footerBottomLinks.slice(0, footerBottomLinks.length - 1) : null;
  const lastFooterBottomLinks =
    footerBottomLinks && footerBottomLinks.length > 0 ? footerBottomLinks[footerBottomLinks.length - 1] : null;

  const menuSetter = (group = getCurrentSite(currentPath)) => {
    menuGroups().then((res) => {
      const menu = get(res, ["menu-groups", group], []);
      const footerMenu = menu.items.filter((item) => item.title === "footer");
      const footerChildren =
        footerMenu.length > 0 ? menu.items.filter((item) => item["parent-id"] === footerMenu[0].id) : [];
      const footerChildrenObj = { children: footerChildren };
      setAuthMenu(completeUrlSetter(footerChildrenObj, sections));
    });
  };

  const defaultMenuItems = (siteMenuItems) => {
    const menuItems =
      siteMenuItems && siteMenuItems.length ? siteMenuItems.find((item) => item.title === "footer") : null;
    setAuthMenu(menuItems);
  };

  useEffect(() => {
    if (global.location.origin.includes("auth")) {
      if (getCurrentSite(currentPath) === "nagorik") {
        menuSetter("nagorik-sangbad");
      } else {
        defaultMenuItems(prothomaloMenuItems);
      }
    } else if (domainSlug === "nagorik") {
      defaultMenuItems(micrositesMenuItems);
    } else {
      defaultMenuItems(prothomaloMenuItems);
    }
  }, [micrositesMenuItems, currentPath]);

  return (
    <div styleName="footer">
      <div styleName={`row1`} className="print-footer-row1">
        <div styleName="logo">{logoRenderer(<DefaultFooterLogo />, currentPath)}</div>

        {authMenu && authMenu.children && authMenu.children.length > 0 ? (
          <div styleName="footer-links" className="print-footer-links">
            <FooterMenuGroup links={authMenu.children.slice(0, 18)} className={"footer-menu-group1"} />
          </div>
        ) : null}
      </div>
      <div styleName="row2" className="print-footer-row2">
        <div styleName="social-links">
          <span styleName="social-links__headline">{staticTexts(lang).followUsText}</span>
          <div className="social-links__items">
            {socialLinks["facebook-url"] && (
              <Link
                aria-label="Prothom Alo Facebook Link"
                href={socialLinks["facebook-url"]}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Facebook fillColor="#1877f2" />
              </Link>
            )}
            {socialLinks["twitter-url"] && (
              <Link
                aria-label="Prothom Alo Twitter Link"
                href={socialLinks["twitter-url"]}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Twitter fillColor="#1da1f2" />
              </Link>
            )}
            {socialLinks["instagram-url"] && (
              <Link
                aria-label="Prothom Alo Instagram Link"
                href={socialLinks["instagram-url"]}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Instagram color1="#eee" color2="#c32aa3" />
              </Link>
            )}
            {socialLinks["youtube-url"] && (
              <Link
                aria-label="Prothom Alo Youtube Link"
                href={socialLinks["youtube-url"]}
                className="youtube-icon"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Youtube color1="#ff0000" />
              </Link>
            )}
          </div>
        </div>
        <div styleName="app">
          <MobilePlayStore />
        </div>
      </div>
      {initialFooterBottomLinks && initialFooterBottomLinks.length > 0 ? (
        <div styleName="bottom-menu">
          <FooterMenuGroup links={initialFooterBottomLinks.slice(0, 8)} />
        </div>
      ) : null}
      <div styleName={`row3 ${lang === "en" ? "eng-row3" : ""}`}>
        <div styleName="copyright">{publisherSettings.copyright || ""}</div>
        {lastFooterBottomLinks && (
          <>
            <div styleName="default-editor" className="print-default-editor">
              {lastFooterBottomLinks["item-type"] === "placeholder" ? (
                <span>{lastFooterBottomLinks.title}</span>
              ) : (
                <a aria-label={lastFooterBottomLinks.title} href={lastFooterBottomLinks.completeUrl}>
                  {lastFooterBottomLinks.title}
                </a>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  sections: get(state, ["qt", "config", "sections"], []),
  micrositesMenuItems: get(state, ["qt", "data", "navigationMenu", "menuItems"], []),
  publisherSettings: get(state, ["qt", "config", "publisher-settings"], {}),
  lang: get(state, ["qt", "config", "publisher-attributes", "lang"], ""),
  prothomaloMenuItems: get(state, ["qt", "data", "navigationMenu", "prothomaloMenuItems"], []),
  pageType: get(state, ["qt", "pageType"], ""),
  socialLinks: get(state, ["qt", "config", "social-links"], {}),
  currentPath: get(state, ["currentPathReducer", "currentPath"], null),
});

DefaultFooterBase.propTypes = {
  publisherSettings: object,
  prothomaloMenuItems: array,
  pageType: string,
  lang: string,
  socialLinks: object,
  currentPath: string,
  domainSlug: string,
  micrositesMenuItems: array,
  sections: array,
};

export const DefaultFooter = connect(mapStateToProps)(DefaultFooterBase);
